import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import detector from "i18next-browser-languagedetector";

//import eng from "./locales/en.json";
import ita from "./locales/it.json";

i18n
  //.use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      /*
      "en-EN": {
        translations: eng,
      },
      */
      "it-IT": {
        translations: ita,
      },
    },
    debug: true,
    lng: "it-IT",
    fallbackLng: "it-IT", // use en if detected lng is not available
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
  });
export default i18n;
